import type { FoodRow } from '@/lib/db';

/**
 * De dónde sale cada número (SPEC 4.1: «la procedencia es visible en la UI»).
 *
 * No es letra pequeña decorativa: un valor de la etiqueta, uno de USDA y uno
 * estimado a partir de otro alimento no merecen la misma confianza, y quien
 * mira la ficha tiene derecho a distinguirlos. La atribución a Open Food Facts
 * es además obligatoria por su licencia ODbL.
 */
export function FoodProvenance({ food }: { food: FoodRow }) {
  const origins = new Set(Object.values(food.sources));
  const estimated = Object.values(food.sources).filter((s) => s === 'estimado').length;

  if (origins.size === 0) return null;

  return (
    <p className="mt-3 text-center text-[11px] leading-relaxed text-[var(--color-text-muted)]">
      {origins.has('off') ? (
        <>
          Datos de{' '}
          <a
            href={`https://es.openfoodfacts.org/producto/${food.barcode ?? ''}`}
            target="_blank"
            rel="noreferrer noopener"
            className="underline"
          >
            Open Food Facts
          </a>
          , bajo licencia ODbL.{' '}
        </>
      ) : null}
      {origins.has('usda') ? 'Datos de USDA FoodData Central (dominio público). ' : null}
      {origins.has('usuario') ? 'Valores introducidos por ti. ' : null}
      {estimated > 0 ? (
        <>
          {estimated === 1 ? '1 valor estimado' : `${estimated} valores estimados`}
          {food.estimatedFrom ? ` a partir de «${food.estimatedFrom.name}»` : ''}: son una
          aproximación, no vienen de la etiqueta.
        </>
      ) : null}
    </p>
  );
}
